// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".css-2b097c-container {\n    position: relative;\n    box-sizing: border-box;\n    width: 312px !important;\n}\n", "",{"version":3,"sources":["webpack://src/components/ApprovalLimits/ApprovalLimits.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;AAC3B","sourcesContent":[".css-2b097c-container {\n    position: relative;\n    box-sizing: border-box;\n    width: 312px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
